export default {"src":"/_next/static/media/je.617abe8c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};